import Heading2 from './Heading2'
export default Heading2
